import axios, { AxiosError } from "axios";
import { alert, custom } from "devextreme/ui/dialog";
import { msalInstance } from "./AuthService";

export function HandleResponseForError(error: AxiosError) {

    // Aborted/cancelled requests don't have a meaningful response - just pass through
    if (
        error?.code === "ECONNABORTED" ||
        error?.code === "ERR_CANCELED" ||
        error?.message === "Request aborted" ||
        axios.isCancel(error)
    ) {
        return Promise.reject(error);
    }

    if(error && error.isAxiosError) {
        // error.request is undefined if the request failed before being sent
        const requestUrl: string = error.request?.responseURL || error.config?.url || "";
        //The initial group call response is handled within the App.tsx file
        if(!requestUrl.endsWith("group")) {
            //if user is unauthorised/forbidden get them logged out and send to the log in screen
            if(error.response && error.response.status == 401) {
                displayAuthErrorMessage("Your session has expired", "Your session has expired, please re-login.");
            }
            else if (error.response && error.response.status == 403) {
                displayAuthErrorMessage("Issue with your user", "There may be an issue with your user, please re-login.");
            }
            //or, display generic error to user
            else if (error.response && error.response.status == 500) {
                alert("There has been an issue with this page. If the problem persists please <a href='/raiseQuery'>contact Event UK</a>.", "Unexpected System Error");
            }
        }
    }
    throw error;
}

const onClickLink = () => {
    sessionStorage.clear();
    msalInstance.logoutRedirect({
        account: msalInstance.getActiveAccount(),
        authority: 'login.microsoftonline.com'
    })
}

// Guard flag to prevent multiple auth error dialogs appearing simultaneously
// when several in-flight API calls all fail with the same 401/403 status.
let authDialogVisible = false;

const displayAuthErrorMessage = (title: string, message: string) => {
    if (authDialogVisible) return;

    authDialogVisible = true;
    let customAlert = custom({
        title: title,
        messageHtml: "<div class='text-center'>" + message + "</div>",
        buttons: [{
            text: "Switch User",
            onClick: onClickLink
        }]
    });

    customAlert.show().then(() => {
        authDialogVisible = false;
    });
}